<template>
  <div class="header-outer">
    <div id="header" class="header navbar navbar-default cus-header">
      <div class="container">
        <div class="head-row d-flex align-items-center w-100">
          <div class="navbar-header">
            <a href="https://dctrainings.com/dashboard/" class="navbar-brand">
              <img
                src="https://dctrainings.com:443/gts/resources/assets/img/new-logo.png"
                class="logowewqeq"
                alt=""
              />
            </a>
          </div>
          <!-- end mobile sidebar expand / collapse button -->
          <span class="main-heading">
            DC Trainings For {{ this.users.PracticeName }}</span
          >
          <!-- begin navbar-right -->
          <button
            @click="toggleNavbar"
            :class="{ close: isNavbarClosed }"
            type="button"
            class="navbar-toggle collapsed cus-togl"
            data-toggle="collapse-side"
            data-target=".side-collapse"
            data-target-2=".cus-togl"
          >
            <span class="icon-bar hamb-top"></span>
            <span class="icon-bar hamb-middle"></span>
            <span class="icon-bar hamb-bottom"></span>
          </button>
          <ul class="nav right-head-user d-flex align-items-center">
            <li class="desktop-view">
              <button class="btn btn-primary" @click="logout">
                <i class="fa fa-sign-out" aria-hidden="true"></i> Log Out
              </button>
            </li>
            <li class="dropdown navbar-user">
              <b-nav-item-dropdown right class="dropdown navbar-user">
                <template slot="button-content">
                  <span class="image">
                    <img
                      :src="`${$server_url}images/profile/${users.Image}`"
                      alt="profile"
                    />
                    <img :src="this.loginUser.url" alt="" />
                    <span class="hidden-xs" style="color: #fff"
                      >{{ this.users.FirstName }}
                      {{ this.users.LastName }}</span
                    >
                    <b class="caret" style="color: #fff"></b>
                  </span>
                  <span class="user-detail">
                    <p class="user-welcome">Welcome</p>
                    <p class="user-name">
                      <span
                        >{{ this.users.Prefix }} {{ this.users.FirstName }}
                        {{ this.users.LastName }}</span
                      >
                      <br />
                      {{ this.users.Status }}
                    </p>
                  </span>
                </template>
                <b-dropdown-item class="preview-item">
                  <router-link :to="{ name: 'edit_profile' }">
                    Edit Profile
                  </router-link>
                </b-dropdown-item>
                <!-- <b-dropdown-item>
                                    <button class="btn btn-primary" @click="logout">
                                        <i class="fa fa-sign-out" aria-hidden="true"></i> Log Out
                                    </button>
                                </b-dropdown-item> -->
              </b-nav-item-dropdown>
              <!-- <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                                <span class="image">

                                    <img :src="this.users.image" alt="">
                                    <span class="hidden-xs" style="color:#fff">{{ this.users.FirstName }} {{
                                        this.users.LastName }}</span> <b class="caret" style="color:#fff"></b>
                                </span>
                                <span class="user-detail">
                                    <p class="user-welcome">Welcome</p>
                                    <p class="user-name"><span>{{ this.users.Prefix }} {{ this.users.FirstName }} {{
                                        this.users.LastName }}</span> <br> {{ this.users.Status }} </p>
                                </span>
                            </a>
                            <ul class="dropdown-menu pull-right">
                                <li><a href="https://dctrainings.com:443/gts/?Module=Home&amp;Page=Profile">Edit Profile</a>
                                </li>
                                <li class="tablet-view">
                                    <button class="btn btn-primary" @click="logout">
                                        <i class="fa fa-sign-out" aria-hidden="true"></i> Log Out
                                    </button>
                                </li>
                            </ul> -->
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      :class="{ 'side-collapse-mobile': isNavbarClosed }"
      class="header cus-header header-botm side-collapse"
      id="tab-navbar"
    >
      <div class="container">
        <ul>
          <li :class="{ active: isLinkActive('user_dashboard') }">
            <router-link class="nav-link" :to="{ name: 'user_dashboard' }"
              ><i class="home-icon icon" aria-hidden="true"></i>
              Home</router-link
            >
          </li>
          <li :class="{ active: isActive2 }">
            <router-link class="nav-link" :to="{ name: 'user_modules' }"
              ><i class="tren-icon icon" aria-hidden="true"></i>
              Training</router-link
            >
          </li>
          <li :class="{ active: isActive }">
            <router-link class="nav-link" :to="{ name: 'practice_dashboard' }">
              <i class="prac-icon icon" aria-hidden="true"></i> My Practice
            </router-link>
          </li>
          <li :class="{ active: isActive3 }">
            <router-link class="nav-link" :to="{ name: 'user_awards' }"
              ><i class="tren-icon icon" aria-hidden="true"></i>
              Resources</router-link
            >
          </li>

          <li :class="{ active: isLinkActive('contact_us') }">
            <router-link class="nav-link" :to="{ name: 'contact_us' }">
              <i class="conta-icon icon" aria-hidden="true"></i> Contact
              Us</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import userAPI from "../userApi";
export default {
  data() {
    return {
      loginUser: {},
      users: [],
      UserID: "",
      server_url: "",
      url: "",
      isNavbarClosed: false,
    };
  },
  methods: {
    getUserInfoForHeader() {
      userAPI.getUserInfoForHeader(
        { UserID: this.loginUser.userID },
        (res) => {
          this.users = res.data.data;
          this.url = res.data.server_url + res.data.data.image;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    isLinkActive(routeName) {
      return this.$route.name === routeName;
    },
    logout() {
      userAPI.userLogout((res) => {
        localStorage.removeItem("userLoginToken");
        localStorage.removeItem("userDetails");
        router.push({ name: "user_login" });
      });
    },
    toggleNavbar() {
      this.isNavbarClosed = !this.isNavbarClosed;
    },
  },
  computed: {
    isActive() {
      return (
        [
          "practice_dashboard",
          "weekly_report",
          "daily_report",
          "success_rate",
          "success_report",
          "quarter_dashboard",
          "result_calendar",
          "add_dashboard_user",
          "view_dashboard_user",
          "practice_setting",
          "billing_information",
          "renew_membership",
          "focuses",
          "focuses_success_report", 
          "edit_dashboard_user",
          "single_user",
          "input_quarter_goal",
          "calendly_integration",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/practice_dashboard") ||
        this.$route.path.startsWith("/dashboard/Calendly") ||
        this.$route.path.startsWith("/weekly_report") ||
        this.$route.path.startsWith("/daily_report") ||
        this.$route.path.startsWith("/success_rate") ||
        this.$route.path.startsWith("/quarter_dashboard") ||
        this.$route.path.startsWith("/result_calendar") ||
        this.$route.path.startsWith("/add_dashboard_user") ||
        this.$route.path.startsWith("/view_dashboard_user") ||
        this.$route.path.startsWith("/success_report") ||
        this.$route.path.startsWith("/practice_setting") ||
        this.$route.path.startsWith("/billing_information") ||
        this.$route.path.startsWith("/renew_membership") ||
        this.$route.path.startsWith("/focuses") ||
        this.$route.path.startsWith("/focuses_success_report")||
        this.$route.path.startsWith("/edit_dashboard_user")||
        this.$route.path.startsWith("/single_user")||
        this.$route.path.startsWith("/input_quarter_goal")
      );
    },
    isActive2() {
      return (
        [
          "user_modules",
          "user_seminar",
          "user_rsvp",
          "user_webinars",
          "skill_set",
          "scott_notes",
          "materials",
          "single_module",
          "scott_notes_material",
          "skill_material",
          "WebinarArchive",
          "SeminarArchive",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/user_modules") ||
        this.$route.path.startsWith("/user_seminar") ||
        this.$route.path.startsWith("/user_rsvp") ||
        this.$route.path.startsWith("/user_webinars") ||
        this.$route.path.startsWith("/skill_set") ||
        this.$route.path.startsWith("/scott_notes") ||
        this.$route.path.startsWith("/materials") ||
        this.$route.path.startsWith("/single_module") ||
        this.$route.path.startsWith("/scott_notes_material")||
        this.$route.path.startsWith("/skill_material")||
        this.$route.path.startsWith("/WebinarArchive")||
        this.$route.path.startsWith("/SeminarArchive")
      );
    },
    isActive3() {
      return (
        [
          "user_awards",
          "members_directory",
          "custom_forms",
          "vendors",
        ].includes(this.$route.name) ||
        this.$route.path.startsWith("/user_awards") ||
        this.$route.path.startsWith("/members_directory") ||
        this.$route.path.startsWith("/custom_forms") ||
        this.$route.path.startsWith("/vendors")
      );
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user; 

    if (user.Status == "DC" || user.Status == "CA") {
      this.$router.push({ name: "user_dashboard" });
    }
    this.UserID = this.loginUser.userID;
    this.getUserInfoForHeader();
  },
};
</script>